import {
  Box, Chip, useMediaQuery, useTheme,
} from '@mui/material';
import { useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import useDraggableScroll from '../../shared/Hooks/useDraggableScroll';
import { deleteStudentsFilter } from '../actions/studentsActions';

interface IStudentsChipsContainerProps {
  filters: boolean;
}

const StudentsChipsContainer = ({ filters }: IStudentsChipsContainerProps ) => {
  const { filterOptions, loadingFilter } = useAppSelector(( state ) => state.student );
  const dispatch = useAppDispatch();
  const ref = useRef( null );
  const { onMouseDown } = useDraggableScroll( ref );
  const theme = useTheme();
  const matchSmDowm = useMediaQuery( theme.breakpoints.down( 'sm' ));
  return (
    <Box
      display="flex"
      gap={2}
      alignItems="center"
      justifyContent={filters || matchSmDowm ? 'center' : 'flex-end'}
      sx={{
        flexWrap: 'nowrap',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%',
      }}
      ref={ref}
      onMouseDown={onMouseDown}
    >
      {filterOptions ? (
        <>
          {filterOptions.active && (
            <Chip
              label={filterOptions.active ? 'Activo' : 'Inactivo'}
              variant="outlined"
              disabled={loadingFilter}
              onDelete={() => dispatch( deleteStudentsFilter({ ...filterOptions, active: null }))}
            />
          )}
          {filterOptions.from && (
            <Chip
              label="Desde"
              variant="outlined"
              disabled={loadingFilter}
              onDelete={() => dispatch( deleteStudentsFilter({ ...filterOptions, from: null }))}
            />
          )}
          {filterOptions.until && (
            <Chip
              label="Hasta"
              variant="outlined"
              disabled={loadingFilter}
              onDelete={() => dispatch( deleteStudentsFilter({ ...filterOptions, until: null }))}
            />
          )}
        </>
      ) : ( <Chip label="No hay filtros" variant="outlined" /> )}
    </Box>
  );
};

export default StudentsChipsContainer;
